<!--
 * @Author: jiaxiuc
 * @Date: 2024-03-21 11:15:06
 * @LastEditors: jiaxiuc
 * @LastEditTime: 2024-04-01
-->
<template>
  <div class="comp-xl-param-condition">
    <jw-space direction="vertical">
      <template v-for="(sub, index) in paramsList" :key="sub.parameters">
        <jw-space style="margin-bottom: 20px">
          <jw-select v-model="sub.type" class="right-content" :placeholder="$t('请选择')" :style="{ width: '120px' }" @change="typeChage($event, sub, index)">
            <jw-option :value="0">{{ $t(hasDataSourceId ? '字段' : '联动参数') }}</jw-option>
            <jw-option :value="1">{{ $t('固定值') }}</jw-option>
            <jw-option v-if="hasDataSourceId" :disabled="sub.disabled" :value="2">{{ $t('数据ID') }}</jw-option>
          </jw-select>

          <div v-if="sub.type == 2" class="hand" :style="{ display: 'flex', 'align- items': 'center', width: '200px', backgroundColor: 'var(--color-fill-3)', padding: '4px 12px', opacity: '0.5', height: '32px', lineHeight: '32px' }">
            <jw-typography-paragraph copyable style="margin-bottom: 0">
              {{ sub.parameters }}
            </jw-typography-paragraph>
          </div>

          <jw-space v-if="sub.type == 0 || sub.type == 1" class="field-name" direction="vertical">
            <jw-select v-model="sub.field" class="right-content" :placeholder="$t('请选择')" :style="{ width: '200px' }" @change="changeChild(index)" allow-search>
              <jw-option v-for="item in getColumns(sub.type)" :key="item.fieldKey" :value="item.fieldKey">{{ item.fieldName }}</jw-option>
            </jw-select>
            <label v-show="sub.field">
              <div v-show="sub.type !== 1 || hasDataSourceId" style="display: flex; align-items: center">
                <span> {{ $t('参数名') }}</span>
                <jw-tooltip v-if="!hasDataSourceId">
                  <template #content>
                    <div>
                      配置步骤:<br />
                      1.打开飞书审批-表单设计<br />
                      2.粘贴参数名至单选/多选字段中联动参数的参数代码中
                    </div>
                  </template>
                  <icon-question-circle :size="14" />
                </jw-tooltip>
                <span>:</span>
                <jw-typography-paragraph class="param-paragraph" copyable style="margin-bottom: 0">
                  {{ sub.parameters }}
                </jw-typography-paragraph>
              </div>
            </label>
          </jw-space>
          <!-- 筛选条件 S -->
          <template v-if="sub.type == 1">
            <jw-select v-if="columns[sub.field]?.fieldKey == 'qccId'" class="right-content" v-model="sub.operation" :placeholder="$t('请选择')" :style="{ width: '120px' }" @change="changeChildTwo($event, index)" allow-search>
              <jw-option v-for="item in ruleForm.qccID" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
            </jw-select>
            <jw-select v-else class="right-content" v-model="sub.operation" :placeholder="$t('请选择')" @change="changeChildTwo($event, index)" :style="{ width: '120px' }" allow-search>
              <jw-option v-for="item in conditions?.[columns?.[sub.field]?.fieldType]" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
            </jw-select>
            <!-- 根据字段类型动态设置筛选值 -->
            <!-- 2 -->
            <template v-if="columns[sub.field]?.fieldType == 2">
              <jw-radio-group @change="changeLastChild($event, sub.field)" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" class="rule-form-item-sub-select" v-model="sub.value">
                <jw-radio v-for="item in JSON.parse(columns[sub.field].fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
              </jw-radio-group>
              <jw-checkbox-group @change="changeLastChild($event, sub.field)" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" class="rule-form-item-sub-select" v-model="sub.value">
                <jw-checkbox v-for="item in JSON.parse(columns[sub.field]?.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
              </jw-checkbox-group>
            </template>
            <!-- 3 -->
            <template v-else-if="columns[sub.field]?.fieldType == 3">
              <jw-checkbox-group @change="changeLastChild($event, sub.field)" v-if="sub.operation == 'in' || sub.operation == 'not_in'" class="rule-form-item-sub-select" v-model="sub.value">
                <jw-checkbox v-for="item in JSON.parse(columns[sub.field]?.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
              </jw-checkbox-group>
              <jw-radio-group @change="changeLastChild($event, sub.field)" v-else-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" class="rule-form-item-sub-select" v-model="sub.value">
                <jw-radio v-for="item in JSON.parse(columns[sub.field].fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
              </jw-radio-group>
            </template>
            <!-- 4 -->
            <template v-else-if="columns[sub.field]?.fieldType == 4">
              <jw-select @change="changeLastChild($event, sub.field)" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" v-model.trim="sub.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" popup-container=".system-form-item" allow-clear allow-search>
                <jw-option v-for="item in JSON.parse(columns[sub.field].fieldExt)" :key="item.value" :title="item.label" :value="item.value">{{ item.label }}</jw-option>
              </jw-select>
              <jw-select @change="changeLastChild($event, sub.field)" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" :placeholder="$t('请选择')" multiple class="rule-form-item-sub-select" v-model.trim="sub.value" popup-container=".system-form-item" allow-search>
                <jw-option v-for="item in JSON.parse(columns[sub.field].fieldExt)" :key="item.value" :title="item.label" :value="item.value">{{ item.label }}</jw-option>
              </jw-select>
            </template>
            <!-- 5 -->
            <template v-else-if="columns[sub.field]?.fieldType == 5">
              <jw-select @change="changeLastChild($event, sub.field)" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" v-model.trim="sub.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" popup-container=".system-form-item" allow-clear allow-search>
                <jw-option v-for="item in JSON.parse(columns[sub.field].fieldExt)" :key="item.value" :title="item.label" :value="item.value">{{ item.label }}</jw-option>
              </jw-select>
              <jw-select @change="changeLastChild($event, sub.field)" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" :placeholder="$t('请选择')" multiple class="rule-form-item-sub-select" v-model.trim="sub.value" popup-container=".system-form-item" allow-search>
                <jw-option v-for="item in JSON.parse(columns[sub.field].fieldExt)" :key="item.value" :title="item.label" :value="item.value">{{ item.label }}</jw-option>
              </jw-select>
            </template>
            <!-- 6 人员选择是一个单框与角色权限中的添加人员一样 -->
            <template v-else-if="columns[sub.field]?.fieldType == 6">
              <fh-person v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" className="system-user-item" :multiple="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" position="bl" :item="{ userList: sub.userList }" @cb="getValUser($event, index)"> </fh-person>

              <!-- <xl-tree-member-modal :tree="tree" v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" @cb="getValUser($event, index)" :multipleDep="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :depart="sub.departList" :user="sub.userList">
                <jw-input-tag v-model="sub.userDept" :max-tag-count="2" style="width: 200px" class="rule-form-item-sub-select" readonly :placeholder="$t('请选择')" />
              </xl-tree-member-modal> -->
            </template>
            <!-- 7数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
            <template v-else-if="columns[sub.field]?.fieldType === 7 && sub.operation != 'null' && sub.operation != 'not_null'">
              <div style="width: 200px" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
              <jw-input-number @change="changeLastChild($event, sub.field)" v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, columns[sub.field])" :formatter="(event) => isShowThousandFormatter(event, columns[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(columns[sub.field], precisionNum)" />
            </template>
            <!-- 日期格式 -->
            <template v-else-if="columns[sub.field]?.fieldType == 8">
              <jw-date-picker @change="changeLastChild($event, sub.field)" v-model="sub.value" :format="columns[sub.field]?.fieldExt" v-if="sub.operation != 'between' && sub.operation != 'null' && sub.operation != 'not_null'" :placeholder="$t('请选择日期范围')" class="rule-form-item-sub-select" popup-container=".system-form-item" position="br" :trigger-props="{ updateAtScroll: true }" />
              <jw-range-picker type="time-range" @change="changeLastChild($event, sub.field)" v-model="sub.value" :format="columns[sub.field]?.fieldExt" v-else-if="sub.operation == 'between'" class="rule-form-item-sub-select" popup-container=".system-form-item" position="br" />
            </template>
            <!-- 9日期范围 -->
            <template v-else-if="columns[sub.field]?.fieldType === 9 && sub.operation != 'null' && sub.operation != 'not_null'">
              <jw-range-picker @change="changeLastChild($event, sub.field)" v-if="columns[sub.field]?.fieldExt === '0'" v-model="sub.value" class="rule-form-item-sub-select" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
              <jw-range-picker @change="changeLastChild($event, sub.field)" v-else-if="columns[sub.field]?.fieldExt === '1'" class="rule-form-item-sub-select" v-model="sub.value" @select="onSelect" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
              <jw-range-picker @change="changeLastChild($event, sub.field)" v-else v-model="sub.value" class="rule-form-item-sub-select" @select="onSelect" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
            </template>
            <!-- 10 级联选择器 :path-mode="true"-->
            <template v-else-if="columns[sub.field]?.fieldType == 10">
              <jw-cascader :path-mode="true" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" class="rule-form-item-sub-select" :options="JSON.parse(columns[sub.field]?.fieldExt)" allow-search v-model="sub.value" @change="changeLastChild($event, sub.field)" :placeholder="$t('请选择')" />
              <jw-cascader :path-mode="true" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" class="rule-form-item-sub-select" :options="JSON.parse(columns[sub.field]?.fieldExt)" allow-search v-model="sub.value" @change="changeLastChild($event, sub.field)" :placeholder="$t('请选择')" multiple />
            </template>
            <!-- 16 金额 -->
            <template v-else-if="columns[sub.field]?.fieldType === 16">
              <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" style="width: 200px" @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, columns[sub.field])" :formatter="(event) => isShowThousandFormatter(event, columns[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(columns[sub.field], precisionNum)" />
            </template>
            <!-- 23百分比 -->
            <template v-else-if="(columns[sub.field]?.fieldType === 23 && sub.operation != 'null' && sub.operation != 'not_null') || (columns[sub.field]?.business?.fieldType == 23 && sub.operation != 'null' && sub.operation != 'not_null')">
              <div style="width: 200px" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
              <jw-input-number @change="changeLastChild($event, sub.field)" v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, columns[sub.field])" :precision="getPrecision(columns[sub.field], precisionNum)">
                <template #append> % </template>
              </jw-input-number>
            </template>
            <!-- 单行文本 obj[sub.field] -->
            <template v-else>
              <jw-input style="width: 200px" v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" v-model.trim="sub.value" :placeholder="$t('请输入')" @change="changeLastChild($event, sub.field, branchIndex)" class="rule-form-item-sub-select" />
              <!-- <div v-else style="width: 200px"></div> -->
            </template>
          </template>
          <!-- 删除当前行 -->
          <icon-minus-circle @click="conditionUpdate(sub, index)" class="del-item" :size="20" />
        </jw-space>
      </template>
      <jw-button type="outline" @click="conditionUpdate()" style="margin-top: -20px" v-if="maxSize ? paramsList.length <= maxSize : true">
        <template #icon>
          <icon-plus />
        </template>
        {{ $t('新建参数') }}
      </jw-button>
    </jw-space>
  </div>
</template>

<script setup>
import { setService } from '@/api/';
import { ref, watch, computed, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import _ from 'lodash';
import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
import dayjs from 'dayjs';
const { t } = useI18n();

// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

const conditions = ref([]);
const ruleForm = ref({
  qccID: [
    {
      label: '为空',
      value: 'null',
      business: null,
      deleted: null
    },
    {
      label: '不为空',
      value: 'not_null',
      business: null,
      deleted: null
    }
  ]
});

const props = defineProps({
  fieldlist: {
    type: Object,
    default: () => {}
  },
  list: {
    type: Array,
    default: () => []
  },
  hasDataSourceId: {
    // 是否需要数据源id
    type: Boolean,
    default: true
  },
  maxSize: {
    type: Number
  },
  fixedList: {
    type: Object,
    default: () => {}
  },
  filterFieldArray: {
    type: Array,
    default: () => []
  }
});

const columns = ref([]);
const filterColumns = ref([]);
const getColumns = (curType) => {
  if (!props.hasDataSourceId) {
    if (curType === 0) {
      //字段需要过滤
      return filterColumns.value;
    }
    if (curType === 1) {
      // 固定值无需过滤
      return columns.value;
    }
  }
  return columns.value;
};

const filterFields = (data) => {
  const filteredEntries = Object.entries(data).filter(([key, value]) => {
    console.log(key);
    return !props.filterFieldArray.includes(value.fieldType);
  });
  const filteredData = Object.fromEntries(filteredEntries);
  return filteredData;
};
watch(
  () => props.fieldlist,
  (list) => {
    if (props.filterFieldArray?.length) {
      list = filterFields(list);
    }
    columns.value = list;
    filterColumns.value = props.fixedList;
  },
  {
    immediate: true,
    deep: true
  }
);
watch(
  () => props.list,
  (list) => {
    //2025年03月18日20:22:29 zl将setTimeout0修改为nextTick
    nextTick(() => {
      initSourceData(list);
    });
  },
  {
    deep: true
  }
);
const paramsList = ref([]);
const initSourceData = (list) => {
  console.log('fieldObj11111', columns.value);
  if (!list?.length) return;
  paramsList.value = list.map((param) => {
    const field = columns.value[param.conditionField] || {};
    const fieldObj = {
      id: param.id,
      type: param.type,
      field: param.conditionField,
      fieldType: field.fieldType,
      parameters: param.parameters,
      fieldId: param.fieldId,
      fieldName: param.fieldName,
      operation: param.operation,
      conditionField: param.conditionField,
      value: param.value
    };
    console.log('fieldObj', fieldObj);
    if (fieldObj.fieldType == '6' && fieldObj.value) {
      const people = JSON.parse(fieldObj.value);
      fieldObj.userList = people.userList;
      fieldObj.departList = people.departList;
      const userNames = computed(() => fieldObj.userList?.map((u) => u.userName));
      const departNames = computed(() => fieldObj.departList?.map((u) => u.departmentName));
      fieldObj.userDept = [...userNames.value, ...departNames.value];
    }
    if (fieldObj.type == 1 && fieldObj.fieldType == 10) {
      if (fieldObj.operation == 'equals' || fieldObj.operation == 'not_equals') {
        //单选
        fieldObj.value = fieldObj.value.split('/');
      } else if (fieldObj.operation == 'in' || fieldObj.operation == 'not_in') {
        //多选
        fieldObj.value = fieldObj.value.split(',').map((item) => {
          return item.split('/');
        });
      }
    }
    if ([2, 3, 4, 5].includes(fieldObj.fieldType)) {
      if (fieldObj.operation == 'in' || fieldObj.operation == 'not_in') {
        fieldObj.value = fieldObj.value?.split(',');
      }
    }
    if (fieldObj.type == 1 && (fieldObj.fieldType == 7 || fieldObj.fieldType == 16 || fieldObj.fieldType == 23)) {
      fieldObj.value = parseFloat(fieldObj.value);
    }
    return fieldObj;
  });
  resetDisabled();
  nextTick().then(() => {
    // setLoading(false);
  });
};
const typeChage = (value, record, index) => {
  console.log('类型切换33', value, record, index);
  record.field = '';
  record.fieldId = '';
  record.fieldName = '';
  record.operation = '';
  record.conditionField = '';
  record.value = '';
  if (record.type == 2) {
    record.operation = 'equals';
    record.fieldName = 'id';
    record.parameters = tools.randomString();
    record.conditionField = 'id';
    record.operation = 'equals';
  }

  // if(value === 0){
  //   //字段 需要取过滤的值
  //   columns.value = props.fixedList
  // }
  // if(value === 1){
  //   // 固定值 无需过滤
  //   columns.value = props.fieldlist
  // }
  resetDisabled();
};
const resetDisabled = () => {
  const record = _.find(paramsList.value, { type: 2 });
  paramsList.value = _.map(paramsList.value, (item) => {
    console.info(record, item);
    if (record && item.type != 2) {
      item.disabled = true;
    } else {
      item.disabled = false;
    }
    return item;
  });
};
const getCondition = async () => {
  try {
    const json = await setService.getDynamic();
    const tmpConditions = [];
    if (!json.error) {
      json.result.forEach((item) => {
        tmpConditions[item.fieldType] = item.conditions; //第二个框
      });
      conditions.value = tmpConditions;
    }
  } catch (e) {
    console.log(e);
  }
};
const conditionUpdate = (data, index) => {
  if (!index && index != 0) {
    const record = _.find(paramsList.value, { type: 2 });
    paramsList.value.push({ type: '', disabled: record ? true : false, parameters: tools.randomString(), fieldId: '', fieldName: '', operation: '', conditionField: '', value: '' });
  } else {
    paramsList.value.splice(index, 1);
  }
  resetDisabled();
};
const changeChild = async (index) => {
  const fieldObj = columns.value[paramsList.value[index].field];
  paramsList.value[index].fieldId = fieldObj.id;
  paramsList.value[index].fieldName = fieldObj.fieldName;
  paramsList.value[index].fieldType = fieldObj.fieldType;
  paramsList.value[index].conditionField = fieldObj.fieldKey;
  paramsList.value[index].operation = '';
  paramsList.value[index].value = null;
};
const changeChildTwo = (e, index) => {
  paramsList.value[index].value = null;
};
const changeLastChild = (e, val) => {
  console.log(111, e, val, paramsList, 333);
};
const getValUser = (v, index) => {
  const userNames = computed(() => v?.userList?.map((u) => u.userName));
  const departNames = computed(() => v?.departList?.map((u) => u.departmentName));
  paramsList.value[index].userDept = [...userNames.value, ...departNames.value];
  paramsList.value[index].userList = v.userList;
  paramsList.value[index].departList = v.departList;
  const userIds = paramsList.value[index].userList.map((c) => c.id);
  const departIds = paramsList.value[index].departList.map((c) => c.id);
  paramsList.value[index].value = JSON.stringify({
    userIds,
    departIds,
    userList: v.userList,
    departList: v.departList
  });
  if (paramsList.value[index].operation === 'equals' || paramsList.value[index].operation == 'not_equals') {
    if (paramsList.value[index].userDept.length > 1) {
      Message.warning(t('请注意，只可选择一个人员或部门哦'));
    }
  }
};
onMounted(() => {
  getCondition();
});
const getData = () => {
  return paramsList.value;
};
defineExpose({
  getData
});
</script>
<style scoped lang="less">
@import './xl-param-condition.less';
</style>
